// @flow @jsx h
import { h, Component } from 'preact'
import styles from './App.css'
import { connect } from '../../lib/provider'
import MapStory from './MapStory'
import MaxViewportRect from './MaxViewportRect'
import Menu from './Menu'
import { menuItems } from './Menu/props'

import type { SectionType } from '../domain'

type Props = {
  sendGaEvent: (Object) => void,
  contextId: string,
  doc: {
    sections: SectionType[]
  }
}

type AppState = {
  viewport: { height: number, width: number }
}

class _App extends Component<Props, AppState> {
  logoElement: HTMLElement

  constructor () {
    super()
    this.state = {
      viewport: { height: -1, width: -1 }
    }
  }

  handleViewportChange = (viewport: any) => {
    if (
      this.state.viewport.height !== viewport.height ||
      this.state.viewport.width !== viewport.width
    ) {
      this.setState({ viewport })
    }
  }

  render () {
    const { doc, contextId } = this.props
    return (
      <div class={styles.app}>
        <MaxViewportRect
          height='100'
          width='100'
          onViewportChange={this.handleViewportChange}
        />
        <a
          className={styles.logo}
          href='http://www.nrk.no/'
          title='Forsiden av NRK.no'>
          <svg width='48.75px' height='18px' aria-hidden='true'>
            <use xlinkHref='#nrk-logo-nrk' />
          </svg>
        </a>
        <Menu menuItems={menuItems} contextId={contextId} />
        <MapStory sections={doc.sections} overlays={[]} labels={[]} viewport={this.state.viewport} sendGaEvent={this.props.sendGaEvent} />
      </div>
    )
  }
}

const connector = connect()
// const connector = connect(mapContextToProps)
export const App = connector(_App)
